import {lazy} from "react";
import Error from "@/components/error/error.tsx";
import {Route} from "react-router";

const UserLogin = lazy(() => import("@/app/identity-access-management/authentication/features/user-login/user-login.tsx"));
const UserRegister = lazy(() => import("@/app/identity-access-management/authentication/features/user-register/user-register.tsx"));
const UserPasswordReset = lazy(
    () => import("@/app/identity-access-management/authentication/features/user-password-reset/user-password-reset.tsx")
);
const UserConfirmedPage = lazy(
    () => import("@/app/identity-access-management/authentication/features/user-confirmed/user-confirmed.tsx")
);

const IdentityAccessManagmentRoutes= [
    <Route path="auth/user-login" element={<UserLogin />} errorElement={<Error/>} />,
    <Route path="auth/user-register" element={<UserRegister />} errorElement={<Error/>} />,
    <Route path="/user/confirmed" element={<UserConfirmedPage />} errorElement={<Error/>}/>,
    <Route path="auth/user-password-reset" element={<UserPasswordReset />} errorElement={<Error/>} />,
];
export default IdentityAccessManagmentRoutes;
